// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.0";import * as Sentry from "@sentry/nextjs";

console.log("[Sentry Client] Initializing with config:", {
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN ? "✓ Set" : "✗ Missing",
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT || "not set",
  nodeEnv: process.env.NODE_ENV,
  enabled: process.env.NODE_ENV !== "development",
});

Sentry.init({
  dsn: "https://dd607b004b194d018fe816843aa7bc58@o4505319319601152.ingest.us.sentry.io/4505591943528448",

  // Disable Sentry in local development
  enabled: process.env.NODE_ENV !== "development",

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Enable sending user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
